import styled from 'styled-components';

export const SdsInputLabelStyled = styled.label`
  color: ${(props) => props.theme.colors.labelCombos} !important;
  font-size: 1em;
  z-index: 901 !important;
  background: linear-gradient(transparent 50%, #e8f0fe 50%) !important;
`;

export const SdsInputStyled = styled.input`
  background-color:  #e8f0fe;
  &:hover {
    border: 1px solid #00000099;
  }
  &:focus {
    border: 2px solid ${(props) => props.theme.colors.borderCombos};
  }
  &:active {
    border: 2px solid ${(props) => props.theme.colors.borderCombos};
  }
`;

export const SdsInputDivStyled = styled.div`
  .sds-label {
    color: ${(props) => props.theme.colors.labelCombos};
  }
`;

export const SdsInputButtonStyled = styled.button`
  background-color: transparent;
  color: ${(props) => props.theme.colors.iconCombos};
  i{
    font-size: 30px !important;
  }
`;
